import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { updateProfitLoss } from '../../../store/Slices/profitLossSlice';
import { SetPLValue } from '../../footer/AccountFooter';
import { calculateProfitLoss } from '../../tab/tabview/netTrade/utils/tradeCalculation';

const ProfitLoss = ({ row }) => {
    const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
    const dispatch = useDispatch()
    const symbol = useSelector(state => state.updateSymbol.symbols?.[row?.symbolId])
    // console.log(symbol)
    const refSymbol = useSelector(state => state.updateSymbol?.symbols?.[symbol?.referenceSymbolId]) || null
    const [floatingPL, setFloatingPL] = useState(0);
    const { accountId: accountID } = useSelector(state => state.accountSummary)
    const accountId = localStorage.getItem("accountID") || accountID;
    const calculateProfitForRow = () => {
    const symbolData = allSymbolParams?.[row?.symbolId];
    const profit = calculateProfitLoss({ row, symbol, refSymbol, symbolData });

    dispatch(updateProfitLoss());
    SetPLValue(`${accountId}-${row?.id}`, profit);
    return profit;
};
    useEffect(() => {
        const updatedPL = calculateProfitForRow();
        setFloatingPL(updatedPL);
    }, [symbol, accountId])

    return (
        <span className={`${floatingPL < 0 ? "red" : "green"}`} >{floatingPL}</span>
    )
}

export default ProfitLoss
